import { render, staticRenderFns } from "./DashboardCRMStaff.vue?vue&type=template&id=21578108&scoped=true"
import script from "./DashboardCRMStaff.vue?vue&type=script&lang=js"
export * from "./DashboardCRMStaff.vue?vue&type=script&lang=js"
import style0 from "./DashboardCRMStaff.vue?vue&type=style&index=0&id=21578108&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21578108",
  null
  
)

export default component.exports